import { Controller } from 'stimulus'
import { getCsrfParams } from '~/common/helpers/csrf'

export default class extends Controller {
  static targets = ['giphyGrid', 'dropdown']

  onGifSelect = (e) => {
    e.stopPropagation()
    const gifObject = e.detail.gifObject
    const csrf = getCsrfParams()
    const body = {}
    body[csrf[0]] = csrf[1]
    body['source_url'] = gifObject.images.original.url
    body['embed_url'] = gifObject.embed_url
    body['thumbnail_url'] = gifObject.images.preview_webp.url
    body['object_name'] = 'ForumPost'
    fetch('/embeds', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json()
        } else {
          return response.json().then((json) => {
            throw new Error(json.error)
          })
        }
      })
      .then((response) => {
        this.hideLoader()
        this.closeDropdown()
        this.updateInputValue(response.id)
        this.addItem(response.id, response.thumbnail_preview, response.preview)
      })
      .catch((error) => {
        this.hideLoader()
        this.inputTarget.focus()
        alert(error)
      })
  }

  addItem(embedId, thumbnail, preview) {
    const previewContainer = this.element
      .closest('.js-dropzone-form')
      .querySelector('.js-splide-container')
    const event = new CustomEvent('splide:addItem', {
      detail: {
        thumbnail: thumbnail,
        preview: preview,
        objectId: embedId,
        objectName: 'embed',
      },
    })
    previewContainer.dispatchEvent(event)
  }

  updateInputValue(embedId) {
    const input = this.element
      .closest('form')
      .querySelector('input[id$="embed_ids_"]')
    if (input.value) {
      input.value += `,${embedId}`
    } else {
      input.value = [embedId]
    }
    this.dispatch('embeds-changed', { prefix: false, bubbles: true })
  }

  closeDropdown = () => {
    this.hideLoader()
    this.unblurGrid()
    this.dropdownTarget.dispatchEvent(new Event('dropdown:close'))
  }

  hideLoader = () => {
    this.giphyGridTarget.dispatchEvent(new Event('hideLoader'))
  }

  unblurGrid = () => {
    this.giphyGridTarget.dispatchEvent(new Event('unblurGrid'))
  }
}
